import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { DialogComponent } from '../dialog.component';
import { ButtonComponent } from '../../../base';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

import { DialogVariants } from 'shared';

export type ConfirmDialogResult = 'CONFIRM' | 'CANCEL';

export interface ConfirmDialogData {
  variant?: DialogVariants;
  title?: string;
  message: string;
  cancelLabel: string;
  confirmLabel: string;
  switchButtonOrder?: boolean;
}

@Component({
  standalone: true,
  selector: 'tngh-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DialogComponent, ButtonComponent],
})
export class ConfirmDialogComponent {
  private dialogData = inject<ConfirmDialogData>(DIALOG_DATA);
  private dialogRef = inject(DialogRef);

  cancelLabel = this.dialogData.cancelLabel ?? 'Cancel';
  confirmLabel = this.dialogData.confirmLabel ?? 'OK';
  message = this.dialogData.message ?? 'Please confirm';
  switchButtonOrder = this.dialogData.switchButtonOrder ?? false;
  title = this.dialogData.title ?? '';
  variant = this.dialogData.variant ?? 'danger';

  closeDialog(value: ConfirmDialogResult): void {
    this.dialogRef.close(value);
  }
}
